/**
 * itapplicationreducer.js
 **/

import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {cloneDeep} from 'lodash';

export function itApplicationReducer(state = initialState.itprocess, action) {
	switch (action.type) {
		case types.UPDATE_ITAPPLICATION: {
			return action.response || state;
		}
		default:
			return state;
	}
}

export function itApplicationDataReducer(state = initialState.itapplicationData, action) {
	switch (action.type) {
		case types.GET_IT_APPLICATION: {
			if (action.response && action.response.data) {
				return {
					...state,
					...action.response,
					data: [...action.response.data]
				};
			}
			break;
		}

		case types.UPDATE_ITAPPLICATION: {
			if (Object.keys(state).length !== 0) {
				if (action.response && !action.error) {
					let clonedState = cloneDeep(state);
					clonedState.data.forEach((itApp, i) => {
						if (itApp.id === action.response.id) {
							clonedState.data[i] = {...itApp, ...action.response};
						}
					});
					return clonedState;
				}
			}
			return state;
		}

		case types.DELETE_ITAPPLICATION: {
			if (Object.keys(state).length !== 0) {
				if (!action.error) {
					let clonedState = cloneDeep(state);
					clonedState.data = clonedState.data.filter((itApp) => itApp.id !== action.itApplicationId);
					return clonedState;
				}
			}
			return state;
		}
		case types.GET_CONTROL_BY_ID: {
			if (action.response) {
				const itApplications = state.data?.concat(
					action.response?.itApplications.filter(
						(itApp) => !state.data.some((existingItApp) => existingItApp.id === itApp.id)
					)
				);
				return {
					...state,
					data: itApplications
				};
			}
		}

		case types.CREATE_ITAPPLICATION_SO: {
			if (Object.keys(state).length !== 0) {
				if (action.response && !action.error) {
					let clonedState = cloneDeep(state);
					clonedState.data.push(action.response);
					return clonedState;
				}
			}
			return state;
		}

		default:
			return state;
	}
}

export function itApplicationDetailsReducer(state = initialState.itAppSODetails, action) {
	switch (action.type) {
		case types.GET_ITAPPSO_BY_ID:
			if (action.response) {
				return action.response;
			}
			break;
		default:
			return state;
	}
}
